<template>
  <!-- 重置密码 -->
  <div class="retrieve-password-box">
    <!-- 步骤条 -->
    <div class="step">
      <img v-if="stepActive===1" src="./assets/images/Forget password_progress bar1.png" alt="">
      <img v-if="stepActive===2" src="./assets/images/Forget password_progress bar2.png" alt="">
      <img v-if="stepActive===3" src="./assets/images/Forget password_progress bar3.png" alt="">
      <img v-if="stepActive===4" src="./assets/images/Forget password_progress bar4.png" alt="">
    </div>
    <!-- 内容组件 -->
    <div class="verification-box">
      <!-- 重置密码 -->
      <ResetPassword v-if="stepActive===1" :stepActive="stepActive" :userTest="userTest" @setUserTest="setUserTest" @setStepActive="setStepActive" @sendUserAccount="sendUserAccount" />
      <!-- 验证 -->
      <Verification v-if="stepActive===2" :stepActive="stepActive" :userTest="userTest" :info="info" @sendVerifyCode="sendVerifyCode" @setStepActive="setStepActive" @changeVerifyMode="changeVerifyMode" />
      <!-- 设置新密码 -->
      <SetNewPassword v-if="stepActive===3" :stepActive="stepActive" :userTest="userTest" :info="info" @setStepActive="setStepActive" />
      <!-- 重置密码成功 -->
      <ResetPasswordSuccess v-if="stepActive===4" :stepActive="stepActive" @setStepActive="setStepActive" />
    </div>
  </div>
</template>

<script>
// 重置密码组件
import ResetPassword from '@/components/resetPassword/resetPassword';
// 验证组件
import Verification from '@/components/verification/verification';
// 设置新密码组件
import SetNewPassword from '@/components/resetPassword/setNewPassword';
// 设置新密码成功组件
import ResetPasswordSuccess from '@/components/resetPassword/resetPasswordSuccess';

export default {
  name: "retrievePassword",
  components: {
    ResetPassword,
    Verification,
    SetNewPassword,
    ResetPasswordSuccess
  },
  data() {
    return {
      // 步骤条选中
      stepActive: 1,
      // 验证内容
      info: {
        loginPhone: null,
        VerifyCode: ''
      },
      // 接收验证类别
      userTest: HAVE_PHONE ? "userPone" : "userEmail",
    }
  },
  mounted() { },
  methods: {
    // 重新设置setStepActive
    setStepActive(data) {
      this.stepActive = data
    },
    // 重置密码---设置验证类别
    setUserTest(data) {
      this.userTest = data
    },
    // 切换验证方式
    changeVerifyMode(data) {
      this.userTest = data
    },
    // 重置密码---电话号码/邮箱
    sendUserAccount(data) {
      if (data.phone) {
        this.info.loginPhone = data.phone
      } else if (data.email) {
        this.info.loginPhone = data.email
      }
    },
    // 注册---获取验证码
    sendVerifyCode(data) {
      this.info.VerifyCode = data
    }
  },
}
</script>

<style lang="less" scoped>
.retrieve-password-box {
  padding-top: 40px;
  box-sizing: border-box;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  .step {
    width: 100%;
    height: 66px;
    text-align: center;
  }
  .verification-box {
    margin: 67px auto 0;
    width: 460px;
    height: 518px;
  }
}
</style>